import React from 'react';
import { Link } from 'react-router-dom';
import { FacebookIcon, InstagramIcon, YoutubeIcon, LinkedinIcon, MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-300 w-full" data-id="element-27">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-28">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8" data-id="element-29">
          <div data-id="element-30">
            <div className="flex items-center space-x-3 mb-4" data-id="element-31">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8eURTgVqvsP8mr9gqSQeVQ/Logos.png" alt="AETHE Logo" className="h-12 w-12 object-contain" data-id="element-32" />
              <h3 className="text-xl font-bold text-white" data-id="element-33">AETHE.IN</h3>
            </div>
            <p className="text-sm mb-4" data-id="element-34">
              Empowering Holistic Health Through Integrative Wisdom
            </p>
            <div className="flex space-x-3" data-id="element-35">
              <a href="https://www.instagram.com/aethe.aiimr/" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors" data-id="element-36">
                <InstagramIcon className="w-5 h-5" data-id="element-37" />
              </a>
              <a href="https://www.facebook.com/aethe.aiimr" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors" data-id="element-38">
                <FacebookIcon className="w-5 h-5" data-id="element-39" />
              </a>
              <a href="https://www.youtube.com/@aiimraethe" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors" data-id="element-40">
                <YoutubeIcon className="w-5 h-5" data-id="element-41" />
              </a>
            </div>
          </div>
          <div data-id="element-42">
            <h4 className="text-white font-semibold mb-4" data-id="element-43">Quick Links</h4>
            <ul className="space-y-2 text-sm" data-id="element-44">
              <li data-id="element-45">
                <Link to="/" className="hover:text-blue-400 transition-colors" data-id="element-46">
                  Home
                </Link>
              </li>
              <li data-id="element-47">
                <Link to="/about" className="hover:text-blue-400 transition-colors" data-id="element-48">
                  About Us
                </Link>
              </li>
              <li data-id="element-49">
                <Link to="/services" className="hover:text-blue-400 transition-colors" data-id="element-50">
                  Services
                </Link>
              </li>
              <li data-id="element-51">
                <Link to="/education" className="hover:text-blue-400 transition-colors" data-id="element-52">
                  Courses
                </Link>
              </li>
              <li data-id="element-53">
                <Link to="/blog" className="hover:text-blue-400 transition-colors" data-id="element-54">
                  Blog
                </Link>
              </li>
              <li data-id="element-55">
                <Link to="/contact" className="hover:text-blue-400 transition-colors" data-id="element-56">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-57">
            <h4 className="text-white font-semibold mb-4" data-id="element-58">Contact Info</h4>
            <ul className="space-y-3 text-sm" data-id="element-59">
              <li className="flex items-start" data-id="element-60">
                <MapPinIcon className="w-4 h-4 mr-2 flex-shrink-0 mt-1" data-id="element-61" />
                <span data-id="element-62">
                  Plot No. 24, Sector B–7, Talkatora Road, Gomti Nagar
                  Extension, Lucknow, UP 226010
                </span>
              </li>
              <li className="flex items-center" data-id="element-63">
                <PhoneIcon className="w-4 h-4 mr-2 flex-shrink-0" data-id="element-64" />
                <a href="tel:+918303699990" className="hover:text-blue-400 transition-colors" data-id="element-65">
                  +91 83036 99990
                </a>
              </li>
              <li className="flex items-center" data-id="element-66">
                <MailIcon className="w-4 h-4 mr-2 flex-shrink-0" data-id="element-67" />
                <a href="mailto:amit.kapoor@aiimr.in" className="hover:text-blue-400 transition-colors" data-id="element-68">
                  amit.kapoor@aiimr.in
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-69">
            <h4 className="text-white font-semibold mb-4" data-id="element-70">Newsletter</h4>
            <p className="text-sm mb-4" data-id="element-71">Subscribe for TCM tips and updates</p>
            <div className="flex" data-id="element-72">
              <input type="email" placeholder="Your email" className="flex-1 px-4 py-2 rounded-l-lg bg-gray-800 border border-gray-700 focus:outline-none focus:border-blue-500 text-sm" data-id="element-73" />
              <button className="bg-blue-600 text-white px-4 py-2 rounded-r-lg hover:bg-blue-700 transition-colors" data-id="element-74">
                <MailIcon className="w-4 h-4" data-id="element-75" />
              </button>
            </div>
            <p className="text-xs mt-3 text-gray-400" data-id="element-76">
              Download Free TCM Self-Care Guide
            </p>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm" data-id="element-77">
          <div className="flex space-x-6 mb-4 md:mb-0" data-id="element-78">
            <a href="#" className="hover:text-blue-400 transition-colors" data-id="element-79">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-blue-400 transition-colors" data-id="element-80">
              Terms of Service
            </a>
          </div>
          <p className="text-gray-400" data-id="element-81">
            © 2024 AETHE.IN. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}